import { useNavigate } from 'react-router-dom'

import Forbidden from 'assets/images/forbidden.png'
import PaveLogo from 'assets/images/pave-logo.svg'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

export default function ForbiddenPage() {
  const navigate = useNavigate()

  const goHome = () => navigate('/')

  return (
    <PDSBox height="100vh">
      <PDSBox marginTop={SIZE.s24} marginLeft="3.5rem">
        <img
          src={PaveLogo}
          alt="Pave Logo"
          width={89}
          height={48}
          onClick={goHome}
          style={{ cursor: 'pointer' }}
        />
      </PDSBox>
      <PDSBox marginTop="20%">
        <PDSBox marginLeft={SIZE.s72}>
          <PDSHeader>Access denied</PDSHeader>
          <PDSBox marginTop={SIZE.s16}>
            <PDSText>You don’t have permissions to access this page.</PDSText>
          </PDSBox>
          <PDSButton
            marginTop={SIZE.s32}
            text="Go Back Home"
            onClick={goHome}
          />
        </PDSBox>
        <img
          style={{ position: 'absolute', right: 0, top: 0, width: '67%' }}
          src={Forbidden}
          alt=""
        />
      </PDSBox>
    </PDSBox>
  )
}
